enum ServiceUtil {
    Sub = 'SUB',
    Button = 'BTN',
    TagStart = 'TAGSTART',
    TagEnd = 'TAGEND',
    Poll = 'POLL',
    Gdpr = 'GDPRALLOW',
    Sign = 'SIGN',
    Form = 'PUBLICFORM',
    Access = 'PUBLICACCESS',
    LinkTrue = 'LINKTRUE',
    LinkFalse = 'LINKFALS',
    Event = 'EVENT'
}

export default ServiceUtil;